export interface TeamMetrics {
  totalCallsToday: number
  totalCallsMonth: number
  conversionRate: number
  conversionRateToday: number
  qualityScoreToday: number
  qualityScoreMonth: number
  missedCallsToday: number
  missedCallsMonth: number
  opportunitiesMonth: number
  bookedMonth: number
}

export interface BonusProgress {
  currentRate: number
  targetRate: number
  opportunities: number
  booked: number
  bookingsNeeded: number
  unlocked: boolean
  progressPercentage: number
}

export interface LeaderboardItem {
  id: number
  operatorName: string
  value: number
  avatarInitials: string
}

export interface TeamActivity {
  id: number
  activityType: 'booking' | 'milestone' | 'team_update'
  description: string
  operatorName?: string
  createdAt: string
}

export interface OperatorPerformance {
  id: number
  name: string
  initials: string
  role?: string
  totalCalls: number
  opportunities: number
  bookings: number
  conversionRate: number
  conversionTrend?: number // Percentage change from previous period
  qualityScore: number
  bonusMultiplier: number
  rank?: number
}

export interface TeamPerformanceData {
  period: Period
  teamMetrics: TeamMetrics
  topConversion: LeaderboardItem[]
  topQuality: LeaderboardItem[]
  recentActivities: TeamActivity[]
  operators: OperatorPerformance[]
  bonusProgress: BonusProgress
  startDate?: string
  endDate?: string
}

// Helper type for period values
export type Period = 'today' | 'month' | 'custom'

// Conversion status thresholds
export const CONVERSION_THRESHOLDS = {
  ELITE: 60,
  STRONG: 55,
  APPROACHING: 50,
} as const

// Quality score thresholds
export const QUALITY_THRESHOLDS = {
  EXCELLENT: 85,
  STRONG: 80,
  ACCEPTABLE: 75,
} as const

// Bonus multiplier tiers
export const BONUS_MULTIPLIERS = {
  ELITE: 125,    // 60%+ conversion
  STRONG: 112,   // 55-59% conversion
  APPROACHING: 105, // 50-54% conversion
  BASE: 95,      // <50% conversion
} as const
